import request from '../utils/request'

// ==================== 流程定义 FlowDef ====================

/**
 * 获取流程定义列表
 */
export function getFlowDefList(params) {
  return request({
    url: '/flowDef/list',
    method: 'get',
    params
  })
}

/**
 * 获取流程定义详情
 */
export function getFlowDef(id) {
  return request({
    url: `/flowDef/${id}`,
    method: 'get'
  })
}

/**
 * 创建流程定义
 */
export function createFlowDef(data, operationPassword) {
  return request({
    url: '/flowDef',
    method: 'post',
    data,
    params: { operationPassword }
  })
}

/**
 * 更新流程定义
 */
export function updateFlowDef(data, operationPassword) {
  return request({
    url: '/flowDef',
    method: 'put',
    data,
    params: { operationPassword }
  })
}

/**
 * 删除流程定义
 */
export function deleteFlowDef(id, operationPassword) {
  return request({
    url: `/flowDef/${id}`,
    method: 'delete',
    params: { operationPassword }
  })
}

// ==================== 流程定义版本 FlowDefLog ====================

/**
 * 获取流程定义的版本列表
 */
export function getFlowDefLogList(flowDefId) {
  return request({
    url: `/flowDefLog/list/${flowDefId}`,
    method: 'get'
  })
}

/**
 * 获取流程定义版本详情（包含 defJson）
 */
export function getFlowDefLog(id) {
  return request({
    url: `/flowDefLog/${id}`,
    method: 'get'
  })
}

/**
 * 获取流程定义的最新版本
 */
export function getLatestFlowDefLog(flowDefId) {
  return request({
    url: `/flowDefLog/latest/${flowDefId}`,
    method: 'get'
  })
}

/**
 * 保存流程设计（创建新版本，不自动应用）
 */
export function saveFlowDefLog(data, operationPassword) {
  return request({
    url: '/flowDefLog',
    method: 'post',
    data,
    params: { operationPassword }
  })
}

/**
 * 更新已有版本的流程设计（原地编辑）
 */
export function updateFlowDefLog(id, data, operationPassword) {
  return request({
    url: `/flowDefLog/${id}`,
    method: 'put',
    data,
    params: { operationPassword }
  })
}

/**
 * 使用指定版本（切换流程定义的当前版本）
 */
export function useFlowDefVersion(flowDefId, version, operationPassword) {
  return request({
    url: `/flowDef/${flowDefId}/useVersion/${version}`,
    method: 'put',
    params: { operationPassword }
  })
}

// ==================== 流程实例 FlowInc ====================

/**
 * 获取可发起的流程列表
 */
export function getAvailableFlows() {
  return request({
    url: '/flowInc/available',
    method: 'get'
  })
}

/**
 * 获取流程表单定义（发起前获取表单结构）
 */
export function getFlowFormDef(flowDefId) {
  return request({
    url: `/flowInc/formDef/${flowDefId}`,
    method: 'get'
  })
}

/**
 * 发起流程
 */
export function startFlow(data) {
  return request({
    url: '/flowInc/start',
    method: 'post',
    data
  })
}

/**
 * 提交/审批/拒绝/终止
 */
export function submitFlow(data) {
  return request({
    url: '/flowInc/submit',
    method: 'post',
    data
  })
}

/**
 * 仅保存表单（不审批、不流转节点）
 */
export function saveFlowForm(data) {
  return request({
    url: '/flowInc/saveForm',
    method: 'post',
    data
  })
}

/**
 * 待办列表
 */
export function getTodoList(params) {
  return request({
    url: '/flowInc/todo',
    method: 'get',
    params
  })
}

/**
 * 已办列表
 */
export function getDoneList(params) {
  return request({
    url: '/flowInc/done',
    method: 'get',
    params
  })
}

/**
 * 我发起的列表
 */
export function getMineList(params) {
  return request({
    url: '/flowInc/mine',
    method: 'get',
    params
  })
}

/**
 * 流程实例详情
 */
export function getFlowIncDetail(id) {
  return request({
    url: `/flowInc/detail/${id}`,
    method: 'get'
  })
}

// ==================== 文件上传 ====================

/**
 * 上传文件（支持多文件）
 * @param {File[]} files 原生File对象数组
 * @returns Promise - data: [{ id, name, size, contentType, url }]
 */
export function uploadFiles(files) {
  const formData = new FormData()
  files.forEach(f => formData.append('file', f))
  return request({
    url: '/upload',
    method: 'post',
    data: formData,
    headers: { 'Content-Type': 'multipart/form-data' },
    timeout: 60000
  })
}
